import React from 'react'

const WelcomeSection = () => {

  return (
    <div className='welcome-text'>
      <h2>Book your Christmas Mini Shoot with Little Munchkin Photography today!</h2>
    </div>
  )
}

export default WelcomeSection